import { useSelector } from 'react-redux'

import importExternalSourceSlice from './importExternalSource'

export const useImportExternalSourceData = () => {
  const reducerState = useSelector((state) => state.importExternalSource)
  return reducerState
}

export const {
  setIsOpenImportedSubscribersResultDialog,
  setIsListenSocketSchoolImport,
  resetImportExternalSourceData,
  setIsOpenImportProgressDialog,
  setIsOpenImportDialog,
  setSchoolImportProcessStatus,
  setShowProgressBar,
} = importExternalSourceSlice.actions

export default importExternalSourceSlice.reducer
